module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0c1e466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Devices/Devices.vue
// module id = 354
// module chunks = 1